<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">终端类别管理</h1>
			<div class="clear">
		  		<div class="fl">
					<el-button @click="showAddCon()"><i class="fa fa-plus"></i> 添加终端类别 </el-button>
				</div>
		  	</div>
			<br />
			<el-table
		    	stripe
				border
			    ref="multipleTable"
			    :data="deviceList"
			    tooltip-effect="dark"
			    style="width: 100%">
			    <el-table-column
			      type="index"
			      width="50">
			    </el-table-column>
			    <el-table-column
			      prop="mount_name"
			      label="设备类别名称"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="communication"
			      label="协议"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="status"
			      label="状态"
			      :formatter="ifActive2"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="created_time"
			      label="创建时间"
			      :formatter="dateFormat">
			    </el-table-column>
			    <el-table-column
			      prop="updated_time"
			      label="更新时间"
			      :formatter="dateFormat">
			    </el-table-column>
			    <el-table-column
		          label="操作">
		          <template slot-scope="scope">
		            <el-button type="text" size="small"
		                       @click="changeStatus(scope.$index, scope.row)">更改状态
		            </el-button>
		            <el-button type="text" size="small"
		                       @click="toTerminalProduct(scope.$index, scope.row)">查看终端产品
		            </el-button>
		          </template>
		        </el-table-column>
			  </el-table>
			<br />
			<div class="text-right">
				<el-pagination
					@current-change="handleCurrentChange"
				  :page-size="pagesize"
				  layout="total, prev, pager, next"
				  :total="totalNum">
				</el-pagination>
			</div>
		</div>
		<!--添加设备类别-->
		<el-dialog title="添加终端类别" :visible.sync="addFlag" width="500px">
        
	        <el-form>
	          <el-form-item label="类别名称" :label-width="formLabelWidth">
	            <el-input v-model="mount_name" placeholder="请输入设备类别名称" auto-complete="off"></el-input>
	          </el-form-item>
	          <el-form-item label="通讯方式" :label-width="formLabelWidth">
	            <el-input v-model="communication" placeholder="请输入通讯方式" auto-complete="off"></el-input>
	          </el-form-item>
	          <el-form-item label="状态" :label-width="formLabelWidth">
	            <el-radio-group v-model="status">
			      <el-radio :label="0">禁用</el-radio>
			      <el-radio :label="1">可用</el-radio>
			    </el-radio-group>
	          </el-form-item>
	        </el-form>
	        <div slot="footer" class="dialog-footer">
	          <el-button @click="addFlag=false">取 消</el-button>
	          <el-button type="primary" @click="confirmAddType()">添 加</el-button>
	        </div>
	    </el-dialog>
	    <loading v-if="showLoading"></loading>
	</div>  
</template>

<script>
	export default {
		mounted() {
			this.$nextTick(function(){
				
				this.getDeviceList();
		  	})
    	},
    	data(){
    		return{
    			deviceList:[],
    			nowPage:1,
    			totalNum:0,
    			pagesize:12,
    			addFlag:false,
    			formLabelWidth:'110px',
       			showLoading:false,
       			mount_name:"",
       			communication:"",
       			status:""
    		}
    	},
    	methods:{
    		getDeviceList(){
    			this.showLoading = true;
				let valiCodeParams={
					uid:this.getCookie('uid'),
					page:this.nowPage,
					pagesize:this.pagesize,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MountManage/MountList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		this.deviceList = res.data.data.datalist;
		        		this.totalNum = res.data.data.totalNumber;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
			toTerminalProduct(index,row){
				let routeUrl = this.$router.resolve({
			          path: "/device/terminalProduct",
			          query: {
			          	id:row.id,
			          	mount_name:row.mount_name
			          }
			     });
			     window.open(routeUrl.href, '_blank');
			},
			//			分页点击事件
			handleCurrentChange(val){
				this.nowPage = val;
				this.getDeviceList();
			},
			showAddCon(){
				this.status = "";
				this.mount_name = "";
				this.communication = "";
				this.addFlag = true;
			},
//			添加类别
			confirmAddType(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					mount_name:this.mount_name,
					communication:this.communication,
					status:this.status,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MountManage/AddMount",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		this.addFlag = false;
		        		this.getDeviceList();
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
			changeStatus(index,row){
				if(row.status=="0"){
					this.status = 1;
				}else{
					this.status = 0;
				}
				let valiCodeParams={
					uid:this.getCookie('uid'),
					id:row.id,
					status:this.status,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MountManage/MountStatus",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		this.$message.success(res.data.msg);
		        		this.getDeviceList();
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
    	}
   }
</script>

<style>
	.search-box2{margin-top: -69px;}
</style>


// WEBPACK FOOTER //
// src/components/device/backgroundTerminal.vue